import request from '@/utils/request'

export function selectLayoutManagement(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/selectLayoutManagement?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}




export function getLargeCategory(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/getLargeCategory`,
        method: 'post',
        data,
    })
}



export function getSubclass(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/getSubclass`,
        method: 'post',
        data,
    })
}

export function updateConfirmStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/updateConfirmStatus?`,
        method: 'post',
        data,
    })
}

export function updateDownloadStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/updateDownloadStatus?`,
        method: 'post',
        data,
    })
}

export function updateSubclassType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassType?`,
        method: 'post',
        data,
    })
}

export function updateSubclassTypeV3(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV3?`,
        method: 'post',
        data,
    })
}
export function updateSubclassTypeV4(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV4?`,
        method: 'post',
        data,
    })
}
export function updateSubclassTypeV5(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV5?`,
        method: 'post',
        data,
    })
}
export function updateSubclassTypeV6(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV6?`,
        method: 'post',
        data,
    })
}
export function updateSubclassTypeV7(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV7?`,
        method: 'post',
        data,
    })
}
export function updateSubclassTypePlate(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypePlate?`,
        method: 'post',
        data,
    })
}
export function LayoutManagementBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/LayoutManagementBatchDelete?`,
        method: 'post',
        data,
    })
}

export function confirmConfirmStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/confirmConfirmStatus?`,
        method: 'post',
        data,
    })
}

export function upDateLayoutManagement(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/upDateLayoutManagement`,
        method: 'post',
        data,
    })
}


export function selectAllLargeCategory(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/selectAllLargeCategory?access=${data}`,
        method: 'post',
    })
}
export function selectAllSubclass(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/selectAllSubclass`,
        method: 'post',
        data,
    })
}